module.exports = __webpack_public_path__ + "img/myMind-red.8725e7e9.svg";